import { Fragment } from "react";
import SearchBar from "./SearchBar";
import HeaderContain from "./HeaderContain";
import { SquareArrowRight03Icon } from "@hugeicons/core-free-icons";
import { useCustomContext } from "../../_helper/customizer";
import { HugeiconsIcon } from "@hugeicons/react";
import { Button } from "react-bootstrap";

const Header = () => {
  const { toggleSidebar, toggleIcon } = useCustomContext();

  const openCloseSidebar = () => {
    toggleSidebar(!toggleIcon);
  };

  return (
    <Fragment>
      <div className="header-wrapper m-0 gap-2">
        <Button
          className="toggle-sidebar btn-xs btn btn-outline btn-secondary btn-icon"
          onClick={() => openCloseSidebar()}
          id="sidebar-toggle"
        >
          <i className="status_toggle sidebar-toggle d-flex">
            <HugeiconsIcon icon={SquareArrowRight03Icon} />
          </i>
        </Button>
        <SearchBar />
        <HeaderContain />
      </div>
    </Fragment>
  );
};
export default Header;
